<script></script>

<script setup>
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ModulHandBuchUpload from '@/js/components/ModulHandBuch/ModulHandBuchUpload.vue'
    import ModulHandBuchList from '@/js/components/ModulHandBuch/ModulHandBuchList.vue'
    import ImportlogViewer from '@/js/components/ImportlogViewer/ImportlogViewer.vue'
    import { useModulHandbuchStore } from '@/js/stores/modulHandbuch'
    import { computed } from 'vue'

    const modulHandbuchStore = useModulHandbuchStore()
    const anzahlModulhandbuecher = computed(() => modulHandbuchStore.totalItems)
    const isLoading = computed(() => modulHandbuchStore.isLoading)
</script>

<template>
    <div>
        <h1 class="mt-3 mx-2">Verwaltung der Modulhandbücher</h1>
        <content-collapse
            title="Import der Modulhandbücher über CSV"
            collapse-key="modulhandbuch-upload"
            is-visible-by-default
        >
            <ModulHandBuchUpload />
        </content-collapse>

        <content-collapse title="Import-Logfile anzeigen" collapse-key="modulhandbuch-log-file">
            <ImportlogViewer filename="csvimport_module.log" />
        </content-collapse>

        <content-collapse
            title="Liste der Modulhandbücher"
            collapse-key="modulhandbuch-list"
            is-visible-by-default
        >
            <template #badge>
                <v-progress-circular
                    v-if="isLoading"
                    indeterminate
                    color="silvergrey"
                    class="ml-2"
                    size="14"
                />
                <v-badge
                    v-else
                    color="silvergrey"
                    text-color="black"
                    inline
                    :content="`${anzahlModulhandbuecher}`"
                />
            </template>
            <ModulHandBuchList />
        </content-collapse>
    </div>
</template>

<style scoped></style>
